import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Saved challenges", -1)
const _hoisted_3 = { class: "flex justify-end" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:block" }, " Start new challenge ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "sm:hidden" }, " Add new ", -1)
const _hoisted_6 = { class: "my-6 px-5 py-6 rounded-md bg-cebai-grey-lighter text-base text-cebai-grey-dark" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Editorial = _resolveComponent("Editorial")!
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_AppButtonRouterLink = _resolveComponent("AppButtonRouterLink")!
  const _component_ContentBlock = _resolveComponent("ContentBlock")!
  const _component_AppContent = _resolveComponent("AppContent")!

  return (_ctx.isAuthenticated)
    ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
    : (_openBlock(), _createBlock(_component_AppContent, { key: 1 }, {
        default: _withCtx(() => [
          _createVNode(_component_ContentBlock, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_Editorial, null, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_AppButtonRouterLink, {
                    to: { name: 'challenges-new' },
                    type: "primary"
                  }, {
                    iconAfter: _withCtx(() => [
                      _createVNode(_component_ArrowRightIcon, { class: "ml-2 stroke-current stroke-2" })
                    ]),
                    default: _withCtx(() => [
                      _hoisted_4,
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", null, [
                  _createTextVNode(" No saved challenges – please "),
                  _createElementVNode("button", {
                    class: "text-cebai-primary font-robotoMedium",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSignUp && _ctx.toggleSignUp(...args)))
                  }, " sign up "),
                  _createTextVNode(" or "),
                  _createElementVNode("button", {
                    class: "text-cebai-primary font-robotoMedium",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleLogin && _ctx.toggleLogin(...args)))
                  }, " log in "),
                  _createTextVNode(" to start saving challenges, sparks & resources ")
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
}